export const Ready2WorkStatus = Object.freeze({
  UNSET: 'unset',
  READY: 'ready',
  NOTREADY: 'notReady',
})
